var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.visible
      ? _c("div", { staticClass: "confirm-mask" }, [
          _c("div", { staticClass: "confirm-container" }, [
            _c("div", { staticClass: "confirm-header relative" }, [
              _c("h3", [_vm._v("支付")]),
              _c("i", {
                staticClass: "el-icon-close absolute",
                on: { click: _vm.confirmClose },
              }),
            ]),
            _vm.payStatus === 0
              ? _c("div", { staticClass: "confirm-content" }, [
                  _c("p", [_vm._v(_vm._s(_vm.paymentText))]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "order-quantity flex items-center justify-center",
                    },
                    [
                      _vm.getPrice()
                        ? _c("div", { staticClass: "Price" }, [
                            _vm._v("¥ " + _vm._s(_vm.totalPriceDisplay)),
                          ])
                        : _vm._e(),
                      _c("el-input-number", {
                        staticStyle: { width: "100px" },
                        attrs: { size: "mini", min: 1 },
                        model: {
                          value: _vm.orderQuantity,
                          callback: function ($$v) {
                            _vm.orderQuantity = $$v
                          },
                          expression: "orderQuantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "payment-type" }, [
                    _c("div", { staticClass: "aliPay flex items-center" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/payment/alipay.png"),
                          alt: "",
                        },
                      }),
                      _c("span", [_vm._v("支付宝支付")]),
                      _c("i", {
                        staticClass: "el-icon-success pointer",
                        class: { active: _vm.activeType === "alipay" },
                        attrs: { id: "aliPay" },
                        on: {
                          click: function ($event) {
                            return _vm.changePay("alipay")
                          },
                        },
                      }),
                    ]),
                    false
                      ? _c("div", { staticClass: "wxPay flex items-center" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/payment/wxpay.png"),
                              alt: "",
                            },
                          }),
                          _c("span", [_vm._v("微信支付")]),
                          _c("i", {
                            staticClass: "el-icon-success pointer",
                            class: { active: _vm.activeType === "wxpay" },
                            staticStyle: { cursor: "not-allowed" },
                            attrs: { id: "wxPay" },
                            on: {
                              click: function ($event) {
                                return _vm.changePay("wxpay")
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.payLoading },
                          on: { click: _vm.handlePayment },
                        },
                        [_vm._v("去支付")]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm.payStatus === 1
              ? _c("div", { staticClass: "confirm-content relative" }, [
                  _c("p", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("请扫描下方二维码完成支付"),
                  ]),
                  _c("p", { staticStyle: { "font-size": "12px" } }, [
                    _c("span", { staticStyle: { "font-weight": "400" } }, [
                      _vm._v("注意："),
                    ]),
                    _vm._v("支付未完成前，请勿离开此页面"),
                  ]),
                  _vm.countdown
                    ? _c("p", { staticClass: "no-wrap" }, [
                        _vm._v("请于"),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              margin: "0 2px",
                              "white-space": "nowrap",
                              "text-align": "center",
                              color: "red",
                              "font-size": "15px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.formattedTime))]
                        ),
                        _vm._v("内支付"),
                      ])
                    : _vm._e(),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        padding: "18px 0 0",
                        "text-align": "center",
                        "font-size": "13px",
                      },
                    },
                    [
                      _vm.resultMessage.includes("订单不存在")
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#ff5555",
                                "font-size": "inherit",
                              },
                            },
                            [_vm._v("订单不存在")]
                          )
                        : _vm.resultMessage.includes("订单已关闭")
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#ff5555",
                                "font-size": "inherit",
                              },
                            },
                            [_vm._v("订单已关闭")]
                          )
                        : _vm.resultMessage.includes("支付失败")
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#ff5555",
                                "font-size": "inherit",
                              },
                            },
                            [_vm._v("支付失败或超时，交易关闭")]
                          )
                        : _vm.resultMessage.includes("支付超时")
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#ff5555",
                                "font-size": "inherit",
                              },
                            },
                            [_vm._v("支付超时")]
                          )
                        : _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#555555",
                                "font-size": "inherit",
                              },
                            },
                            [_vm._v(_vm._s(_vm.resultMessage))]
                          ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "text-center",
                      staticStyle: {
                        width: "150px",
                        height: "150px",
                        margin: "10px auto 4px",
                      },
                    },
                    [
                      !_vm.showInvalidCode
                        ? _c("QRCode", {
                            attrs: {
                              qrUrl: _vm.payData.qrcode,
                              qrLogo:
                                _vm.activeType === "alipay"
                                  ? require("@/assets/images/payment/alipay.png")
                                  : require("@/assets/images/payment/wxpay.png"),
                              errorText: _vm.errorText,
                            },
                          })
                        : _c(
                            "div",
                            {
                              staticClass: "relative",
                              staticStyle: { width: "150px", height: "150px" },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "150",
                                  height: "150",
                                  src: require("@/assets/images/payment/qrcode.png"),
                                  alt: "",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute qrcode-mask flex-column items-center justify-center",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "reinitiate-btn",
                                      on: { click: _vm.handleBack },
                                    },
                                    [_vm._v("重新支付")]
                                  ),
                                  _c("p", [_vm._v("二维码已过期")]),
                                ]
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "padding-bottom": "18px",
                        "font-size": "12px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.activeType === "alipay"
                            ? "支付宝扫一扫支付"
                            : "微信扫一扫支付"
                        )
                      ),
                    ]
                  ),
                ])
              : _vm.payStatus === 2
              ? _c("div", { staticClass: "confirm-content" }, [
                  _c("h4", { staticStyle: { "font-size": "15px" } }, [
                    _vm._v("支付成功！"),
                  ]),
                  _c("h4", { staticStyle: { padding: "50px 0" } }, [
                    _vm._v(
                      "您的" +
                        _vm._s(_vm.payType) +
                        _vm._s(
                          _vm.payType === "人才报告" ||
                            _vm.payType === "引文报告"
                            ? "下载次数已更新，可以继续下载。"
                            : "访问次数已更新，可以继续访问。"
                        )
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "buttons",
                      staticStyle: { margin: "0 0 10px" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("我知道了")]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            false
              ? _c(
                  "div",
                  { staticStyle: { padding: "20px", "font-size": "14px" } },
                  [
                    _c("hr", { staticStyle: { border: "1px solid red" } }),
                    _c(
                      "div",
                      { staticClass: "flex items-center" },
                      [
                        _c("span", [_vm._v("切换状态：")]),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.payStatus = 0
                              },
                            },
                          },
                          [_vm._v("0")]
                        ),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.payStatus = 1
                              },
                            },
                          },
                          [_vm._v("1")]
                        ),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.payStatus = 2
                              },
                            },
                          },
                          [_vm._v("2")]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }